import React from "react";
import { icons, LucideProps } from "lucide-react";
import cx from "clsx";

export type LucideIconNameType = keyof typeof icons;

interface LucideIconProps extends LucideProps {
  icon: LucideIconNameType;
}

const DEFAULT_ICON: LucideIconNameType = "Star";

export const getIconName = (name: string): LucideIconNameType => {
  if (name in icons) return name as LucideIconNameType;
  return DEFAULT_ICON;
};

export function LucideIcon({
  icon,
  className = "",
  size = 16,
  strokeWidth = 2,
  ...restProps
}: LucideIconProps) {
  const Icon = icon && icon in icons ? icons[icon] : null;
  return Icon ? (
    <Icon
      size={size}
      strokeWidth={strokeWidth}
      aria-hidden="true"
      className={cx("text-primary", className)}
      {...restProps}
    />
  ) : null;
}
